import { render, staticRenderFns } from "./DeslindeFiltros.vue?vue&type=template&id=54c204ba&"
import script from "./DeslindeFiltros.vue?vue&type=script&lang=js&"
export * from "./DeslindeFiltros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports